import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export default function DealDetailSkeleton() {
  return (
    <div className="w-full min-w-0" role="status" aria-label="Loading deal details">
      <Card className="rounded-xl border-dash-border p-4 shadow-none sm:p-6">
        <Skeleton className="h-4 w-28" />
        <div className="mt-6 flex flex-col justify-between gap-5 sm:flex-row">
          <div className="flex-1"><Skeleton className="h-9 w-3/5" /><Skeleton className="mt-3 h-4 w-2/5" /></div>
          <div className="flex gap-2"><Skeleton className="h-9 w-24" /><Skeleton className="h-9 w-28" /></div>
        </div>
        <div className="mt-6 flex items-center gap-4"><Skeleton className="h-2 flex-1 rounded-full" /><Skeleton className="h-4 w-28" /></div>
        <div className="mt-6 flex gap-5 border-t border-dash-border pt-4">{[0, 1, 2, 3, 4].map((item) => <Skeleton key={item} className="h-4 w-20" />)}</div>
      </Card>
      <div className="mt-3 grid gap-4 lg:grid-cols-3">
        <Card className="rounded-xl border-dash-border p-6 shadow-none lg:col-span-2"><Skeleton className="h-6 w-40" />{[0, 1, 2, 3, 4].map((row) => <div key={row} className="mt-5 flex items-center gap-4"><Skeleton className="size-9 rounded-full" /><div className="flex-1"><Skeleton className="h-4 w-3/5" /><Skeleton className="mt-2 h-3 w-2/5" /></div><Skeleton className="h-8 w-20" /></div>)}</Card>
        <Card className="rounded-xl border-dash-border p-6 shadow-none"><Skeleton className="h-6 w-32" />{[0, 1, 2, 3].map((row) => <div key={row} className="mt-6"><Skeleton className="h-3 w-20" /><Skeleton className="mt-2 h-5 w-4/5" /></div>)}</Card>
      </div>
      <span className="sr-only">Loading deal workspace…</span>
    </div>
  );
}
